/**
 * Shared Plan Data — Single Source of Truth
 * 
 * Used by RegisterPlan.jsx and UpgradePlanModal in OrganizationSettings.jsx
 * Keep in sync with backend/services/plans.py
 */

export const PLANS_DATA = {
  free: {
    id: "free",
    name: "Free",
    monthlyPrice: 0,
    annualPrice: 0,
    minSeats: 1,
    description: "Ideal para comenzar",
    subtitle: "Cumple con lo básico",
    highlight: false,
    hasTrial: false,
    features: [
      "10 clientes",
      "200 MB almacenamiento",
      "3 onboardings/mes",
      "5 screenings/mes",
      "3 PDFs/mes",
      "KYC básico",
      "Screening PEP/OFAC",
      "Captura manual",
      "Logo en PDFs",
      "Solo rol Owner",
    ],
    shortFeatures: [
      "10 clientes",
      "200 MB storage",
      "KYC + Screening PEP/OFAC",
      "3 PDFs/mes",
      "1 usuario",
    ],
  },
  basic: {
    id: "basic",
    name: "Basic",
    monthlyPrice: 19,
    annualPrice: 187,
    minSeats: 1,
    description: "Para equipos pequeños",
    subtitle: "Todo lo de Free, más:",
    highlight: false,
    hasTrial: false,
    features: [
      "50 clientes",
      "2 GB almacenamiento",
      "15 onboardings/mes",
      "30 screenings/mes",
      "15 PDFs/mes",
      "Solo rol Owner",
    ],
    shortFeatures: [
      "Incluye Free",
      "50 clientes",
      "2 GB storage",
      "15 onboardings/mes",
      "30 screenings/mes",
    ],
  },
  standard: {
    id: "standard",
    name: "Standard",
    monthlyPrice: 39,
    annualPrice: 384,
    minSeats: 3,
    description: "Cumple con la ley",
    subtitle: "Todo lo de Basic, más:",
    highlight: true,
    hasTrial: false,
    features: [
      "250 clientes",
      "10 GB almacenamiento",
      "50 onboardings/mes",
      "100 screenings/mes",
      "50 PDFs/mes",
      "Reportes XML SAT/UIF",
      "Dashboard de cumplimiento",
      "Rol adicional: Admin",
    ],
    shortFeatures: [
      "Incluye Basic",
      "250 clientes",
      "Reportes XML SAT/UIF",
      "Dashboard de cumplimiento",
      "Roles: Owner + Admin",
    ],
  },
  pro: {
    id: "pro",
    name: "Pro",
    monthlyPrice: 59,
    annualPrice: 580,
    minSeats: 5,
    description: "Cumple eficientemente",
    subtitle: "Todo lo de Standard, más:",
    highlight: false,
    hasTrial: true,
    features: [
      "500 clientes",
      "50 GB almacenamiento",
      "150 onboardings/mes",
      "300 screenings/mes",
      "150 PDFs/mes",
      "300 OCR/mes",
      "OCR automático (INE/pasaporte)",
      "Bitácora / audit log",
      "API de integración",
      "Roles: Oficial de Cumplimiento, Capturista",
    ],
    shortFeatures: [
      "Incluye Standard",
      "500 clientes",
      "OCR automático",
      "Bitácora + API",
      "Roles avanzados",
    ],
  },
  enterprise: {
    id: "enterprise",
    name: "Enterprise",
    monthlyPrice: -1,
    annualPrice: -1,
    minSeats: 1,
    description: "Solución a medida",
    subtitle: "Todo lo de Pro, más:",
    highlight: false,
    hasTrial: false,
    isEnterprise: true,
    features: [
      "Límites según contrato",
      "Dominio propio",
      "White-label (quitar marca Notalia)",
      "Colores personalizados",
      "Roles personalizados",
      "Soporte dedicado + SLA",
    ],
    shortFeatures: [
      "Incluye Pro",
      "White-label",
      "Dominio propio",
      "SLA garantizado",
      "Soporte dedicado",
    ],
  },
};

export const PLANS_ORDER = ["free", "basic", "standard", "pro", "enterprise"];

export const PLAN_HIERARCHY = ["free", "basic", "standard", "pro", "enterprise"];

export function getPlanData(planId) {
  return PLANS_DATA[planId] || PLANS_DATA.free;
}

export function getPrice(planId, billingPeriod) {
  const plan = PLANS_DATA[planId];
  if (!plan) return 0;
  return billingPeriod === "annual" ? plan.annualPrice : plan.monthlyPrice;
}

export function getPriceLabel(billingPeriod) {
  return billingPeriod === "annual" ? "USD/usuario/año" : "USD/usuario/mes";
}
